import {DG_axios} from "../../../../custom/axios";

const BASE_URI = `/dogoo/onleave-config-rest/v2.0/onleave-configs`;

export const loadDetailOnLeaveConfigApi = async (id) => {

    const response = await DG_axios.get(`${BASE_URI}/${id}`);

    return response.data || [];
};

export const loadOnLeaveConfig = async (params) => {
    const config = {params: params};

    const response = await DG_axios.get(BASE_URI, config);

    return response.data || [];
};

export const addOnLeaveConfigApi = async (leaveSettings) => {

    const response = await DG_axios.post(BASE_URI, leaveSettings);

    return response.data || [];
};

export const deleteOnLeaveConfigApi = async (id) => {

    const response = await DG_axios.delete(`${BASE_URI}/${id}`);

    return response.data || [];
};

export const updateOnLeaveConfigApi = async (id, leaveSetting) => {

    const response = await DG_axios.put(`${BASE_URI}/${id}`, leaveSetting);

    return response.data || [];
};

export const changeStatusOnLeaveConfigApi = async (onLeaveConfigId, status) => {

    const response = await DG_axios.put(`${BASE_URI}/${onLeaveConfigId}/approval`, {status: status});

    return response.data || [];
};
